// extracted by mini-css-extract-plugin
module.exports = {"landscape-card":"miniProductCard_landscape-card__3ZB1S","image":"miniProductCard_image__280UY","product-details":"miniProductCard_product-details__2PNLq"};